var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid';
import { Translate } from "../../../I18N";








const calculateMorePages = (currentPage, totalPages) => {
  let page = currentPage + 1;
  const pages = [];

  while (pages.length < 5) {
    if (page + 1 === totalPages) {
      break;
    }

    pages.push((page + 1).toString());
    page += 1;
  }

  return pages;
};

const Paginator = ({ currentPage, totalPages, buildUrl, preventScrollReset }) => {
  const page = Number(currentPage);
  const lastPage = Number(totalPages);
  const isFirstPage = page === 1;
  const isLastPage = currentPage === totalPages;
  const shouldDisplayShowMore = page + 1 !== lastPage && !isLastPage;
  const [showMore, setShowMore] = useState(lastPage - page < 6);

  return /*#__PURE__*/(
    _jsx("nav", { "aria-label": "Pagination" }, void 0, /*#__PURE__*/
    _jsx("ul", { className: "flex flex-wrap items-center" }, void 0, /*#__PURE__*/
    _jsx("li", {}, "previous",
    isFirstPage ? /*#__PURE__*/
    _jsx("button", {
      type: "button",
      disabled: true,
      className: "block px-3 py-2 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300" }, void 0, /*#__PURE__*/

    _jsx(ChevronLeftIcon, { className: "w-[17px]" })
    ) : /*#__PURE__*/

    _jsx(Link, {
      to: buildUrl((page - 1).toString()),
      preventScrollReset: preventScrollReset,
      className: "block px-3 py-2 ml-0 leading-tight text-gray-500 bg-white rounded-l-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "sr-only" }, void 0, "Previous"), /*#__PURE__*/
    _jsx(ChevronLeftIcon, { className: "w-[17px]" })
    )

    ),

    !isFirstPage && /*#__PURE__*/
    _jsx("li", {}, "first", /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl('1'),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0,
    "1"

    )
    ),


    !isFirstPage && page - 1 !== 1 && /*#__PURE__*/
    _jsx("li", {}, page - 1, /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl((page - 1).toString()),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0,

    page - 1
    )
    ), /*#__PURE__*/


    _jsx("li", {}, "current", /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl(currentPage),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-2 leading-tight text-blue-600 bg-blue-50 border border-blue-300" }, void 0,

    currentPage
    )
    ),

    !isLastPage && page + 1 !== lastPage && /*#__PURE__*/
    _jsx("li", {}, page + 1, /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl((page + 1).toString()),
      preventScrollReset: preventScrollReset,
      "aria-current": "page",
      className: "px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0,

    page + 1
    )
    ),


    shouldDisplayShowMore && (
    showMore ?
    calculateMorePages(page, lastPage).map((pageNumber) => /*#__PURE__*/
    _jsx("li", {}, `more-${pageNumber}`, /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl(pageNumber),
      preventScrollReset: preventScrollReset,
      className: "px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0,

    pageNumber
    )
    )
    ) : /*#__PURE__*/

    _jsx("li", {}, "more", /*#__PURE__*/
    _jsx("button", {
      onClick: () => setShowMore(true),
      type: "button",
      className: "h-[35px] px-3 py-2 m-0 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "sr-only" }, void 0, "Show more"), "..."

    )
    )),


    !isLastPage && /*#__PURE__*/
    _jsx("li", {}, "last", /*#__PURE__*/
    _jsx(Link, {
      to: buildUrl(totalPages),
      preventScrollReset: preventScrollReset,
      className: "px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0,

    totalPages
    )
    ), /*#__PURE__*/


    _jsx("li", {}, "next",
    isLastPage ? /*#__PURE__*/
    _jsx("button", {
      type: "button",
      disabled: true,
      className: "block px-3 py-2 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300" }, void 0, /*#__PURE__*/

    _jsx(ChevronRightIcon, { className: "w-[17px]" })
    ) : /*#__PURE__*/

    _jsx(Link, {
      to: buildUrl((page + 1).toString()),
      preventScrollReset: preventScrollReset,
      className: "block px-3 py-2 leading-tight text-gray-500 bg-white rounded-r-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700" }, void 0, /*#__PURE__*/

    _jsx(Translate, { className: "sr-only" }, void 0, "Next"), /*#__PURE__*/
    _jsx(ChevronRightIcon, { className: "w-[17px]" })
    )

    )
    )
    ));

};

export { Paginator };